<template>
    <div class="payment-page">
        <img src="@/assets/Image/NoticeBar-img.png" class="payment-NoticeBar" />
        <div class="payment-content">
            <div class="payment-banner-price-address-pay-box">
                <!-- 轮播图 -->
                <div class="payment-banner-box">                    
                    <van-swipe lazy-render :show-indicators="false" @change="vanSwipeChange" ref="vanSwipeBanner">
                        <van-swipe-item v-for="item in pbType" :key="item.id" class="banner-item">
                            <img class="banner-img" :src="item.pre_img" />
                            <div :class="['comp-name',planCompantNameLen(compantyName)]">{{ compantyName }}</div>
                        </van-swipe-item>
                    </van-swipe>
                    <div class="indicators-list-ul">
                        <div :class="['indicators-list-li',{'indicator-active':index === initialSwipeNum}]" v-for="(item,index) in pbType" :key="item.id" @click="initialSwipeChange(index)"></div>
                    </div>
                </div>
                <!-- 牌匾列表 -->
                <div class="payment-list-ul">
                    <div :class="['payment-list-li',{'li-active':index === initialSwipeNum}]" v-for="(item,index) in pbType" :key="item.id" @click="initialSwipeChange(index)">
                        <div class="li-title-size">
                            <div class="li-title">{{ item.material}}边框（含审核费用）</div>
                            <div class="li-size">高{{ item.size_desc.split('*')[0] }} * 宽{{ item.size_desc.split('*')[1] }}</div>
                        </div>
                        <div class="li-price"><span class="span">¥</span><span class="price-span">{{ Number(item.price)}}</span></div>
                    </div>
                </div>
                <!-- 收货地址 -->
                <div class="expressage-list-box">
                    <div class="expressage-icon-provinces">
                        <img src="@/assets/icon/expressage-icon-01.png" class="expressage-icon" />
                        <div class="expressage-p expressage-first">{{ provincesName[0] }}</div>
                        <div class="expressage-p">快递：免运费</div>
                    </div>
                    <div class="expressage-addressInfo">
                        <img src="@/assets/icon/expressage-icon-02.png" class="address-icon" />
                        <div class="address-info">
                            <div class="info-name-phone">收货信息：<span class="name-span">{{ option.name }}</span><span class="phone-span">{{ option.phone }}</span></div>
                            <div class="address-p">{{ option.provinces + option.site }}</div>
                        </div>
                        <img src="@/assets/icon/right-icon.png" class="right-icon" @click="addressPopupStatus=true" />                       
                    </div>
                </div>
                <!-- 支付方式 -->
                <div class="pay-select">
                    <div :class="['zfb-wx',{'zfb-wx-active':payType}]" @click="payType = true" v-if="payObj.wxpay">
                        <img class="zfb-wx-icon" src="@/assets/icon/WeChat-icon.png">
                        <span class="mar84">微信支付</span>                       
                    </div>
                    <div :class="['zfb-wx',{'zfb-wx-active':!payType}]" @click="payType = false" v-if="payObj.alipay && !$store.state.is_weixin_app">
                        <img class="zfb-wx-icon" src="@/assets/icon/Alipay-icon.png">
                        <span class="mar84">支付宝支付</span>                       
                    </div>
                </div>
                <!-- 流程 -->
                <div class="process-list-ul">
                    <div class="process-list-li">
                        <div class="li-index">01</div>
                        <div class="li-title">支付后审核</div>
                    </div>
                    <div class="process-list-li">
                        <div class="li-index">02</div>
                        <div class="li-title">制作牌匾</div>
                    </div>
                    <div class="process-list-li">
                        <div class="li-index">03</div>
                        <div class="li-title">物流派送</div>
                    </div>
                </div>
            </div>
            <aboutUsC />
        </div>   
        
        <div class="payment-btn-select-box">                   
            <img src="@/assets/Image/payment-btn-bg.png" class="payment-btn-img" @click="payFun()" />  
            <div class="payment-btn-title" @click="payFun()">立即支付 ¥{{ Number(pbType[initialSwipeNum].price)}}</div>
            <div class="promiseBook-box">
                <img class="promiseBook-img"
                    @click="explain = true"
                    v-show="!explain"
                    src="@/assets/icon/index-noSelected-icon.svg"
                />
                <img class="promiseBook-img"
                    @click="explain = false"
                    v-show="explain"
                    src="@/assets/icon/index-selected-icon.svg"
                />
                <div class="promiseBook"> 
                    <span class="promiseBook-p" @click="explain = !explain">支付前请阅读并同意</span>
                    <span class="promiseBook-span" @click="serviceDescriptionStatus = true">《立信计划牌匾服务说明》</span>
                </div>
            </div>
        </div>
        <shippingC @submit="submitFun" @addressPopupClose="addressPopupStatus=false" v-if="addressPopupStatus" />
        <myToast ref="mytoast" :msg="msg" />
        <!-- 《立信计划牌匾服务说明》 -->
        <serviceDescription v-if="serviceDescriptionStatus" @serviceDescriptionClose="serviceDescriptionStatus = false" />
    </div>
</template>

<script>
import myToast from "@/components/myToast";
import shippingC from "@/components/shipping";
import aboutUsC from "@/components/aboutUs";
import serviceDescription from "@/components/serviceDescription";
import {
    orderInfoApi,
    orderFormApi,
    indexApi,
    saveAddressApi,
    orderPayApi,
} from "@/api/index.js";

function onBridgeReady(option, callback) {
    WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
            appId: option.appId, //公众号ID，由商户传入
            timeStamp: option.timeStamp, //时间戳，自1970年以来的秒数
            nonceStr: option.nonceStr, //随机串
            package: option.package,
            signType: option.signType, //微信签名方式：
            paySign: option.paySign,
        },
        function (res) {
            if (res.err_msg == "get_brand_wcpay_request:ok") {
                // 使用以上方式判断前端返回,微信团队郑重提示：
                // res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                callback && callback();
            } else {
                console.log(res.err_msg);
            }
        }
    );
}
function iswxBridge() {
    if (typeof WeixinJSBridge == "undefined") {
        if (document.addEventListener) {
            document.addEventListener(
                "WeixinJSBridgeReady",
                onBridgeReady,
                false
            );
        } else if (document.attachEvent) {
            document.attachEvent("WeixinJSBridgeReady", onBridgeReady);
            document.attachEvent("onWeixinJSBridgeReady", onBridgeReady);
        }
    }
}
export default {
    components: {
        aboutUsC,
        shippingC,
        myToast,
        serviceDescription,
    },
    data() {
        return {
            initialSwipeNum: 0, //初始轮播图位置
            book: {
                title: "",
                content: "",
                name: "",
            },
            msg: "32322",
            plaque: true, //true 木质牌匾 false 金属牌匾
            compantyName: "公司/个体户名称xxxxxx",
            payType: false, //true 微信支付 false 支付宝支付
            explain: true, //立信计划牌匾服务说明
            addressPopupStatus:false,    //地址弹窗状态
            serviceDescriptionStatus:false,    //立信计划牌匾服务说明状态
            option: {
                name: "",
                phone: "",
                provinces: "",
                site: "",
            },
            provincesName: [],
            cid: "",
            pbType: [
                {
                    id: 1,
                    material: "木质",
                    material_format: "木质材质",
                    name: "立信商户荣誉牌匾",
                    pre_img: "",
                    price: "0.00",
                    size_desc: "24cm*31cm",
                    size_desc_format: "尺寸: 24cm*31cm",
                    tag: "审核费用+木质牌匾",
                },
                {
                    id: 2,
                    material: "金属",
                    material_format: "金属材质",
                    name: "立信商户荣誉牌匾",
                    pre_img: "",
                    price: "0.00",
                    size_desc: "24cm*31cm",
                    size_desc_format: "尺寸: 24cm*31cm",
                    tag: "审核费用+金属牌匾",
                },
            ],
            payObj:{},      //当前接口下发微信和支付宝的支付的状态：true为显示
        };
    },
    created() {
        iswxBridge();
        this.cid = this.$route.params.cid;
        console.log(this.$route)
        if (this.cid) {
            if (this.$store.state.companyName) {
                this.compantyName = this.$store.state.companyName;
            } else {
                this.indexApiFun();
            }
            this.getAddressFun();
            this.getForm();    
            //判断当前是否存在succeed-表示支付后的回调
            if(this.$route.query.succeed && this.$route.query.succeed=='succeed'){
                this.orderInfoApiFun();
            }
        } else {
            this.$toast("企业ID为空");
        }
    },
    methods: {
        setlocalStorageFun(option) {
            window.localStorage.setItem(
                "address_yuixin",
                JSON.stringify(option)
            );
        },
        orderInfoApiFun() {
            let self = this;
            // console.log("323");
            orderInfoApi(self.cid).then((res) => {
                if(res.code == 200){
                    if(res.data.ispay) {
                        self.util.skipUrl('/succeed/'+self.cid,{},'replace');
                    }
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }               
            });
        },
        indexApiFun() {
            let self = this;
            indexApi(self.cid).then((res) => {
                if(res.code == 200){
                    self.compantyName = res.data.comp_name;
                    self.book.name = res.data.comp_name;
                    self.book.title = res.data.shouxin_agreement.title;
                    self.book.content = res.data.shouxin_agreement.info;
                    let info = res.data.shipping_address;
                    let option = {
                        name: info.name,
                        phone: info.mobile,
                        provinces:
                            info.pro_code_format +
                            info.city_code_format +
                            info.gov_code_format,
                        site: info.address,
                        provincesCode: [
                            info.pro_code,
                            info.city_code,
                            info.gov_code,
                        ],
                        provincesName: [
                            info.pro_code_format,
                            info.city_code_format,
                            info.gov_code_format,
                        ],
                    };
                    self.setlocalStorageFun(option);  
                                        
                    let options = self.util.shareData();
                    options.link = `${location.origin}/${self.cid}`;
                    options.title = res.data.comp_name;
                    // console.log(options)
                    //微信分享触发事件
                    self.util.weixinShareFun(options);
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }                
            });
        },
        getForm() {
            let self = this,obj = { cid: self.cid };
            if(self.$route.query.version)obj.version = String(self.$route.query.version); 
            orderFormApi(obj).then((res) => {
                if(res.code == 200){
                    self.pbType = res.data.products;
                    self.payObj = res.data.pay;
                    //payType: true, //true 微信支付 false 支付宝支付
                    // if(!res.data.pay.wxpay && res.data.pay.alipay)self.payType = false;
                    if(self.$store.state.is_weixin_app)self.payType = true;
                    // console.log(self.payObj)
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }                
            });
        },
        getAddressFun() {
            let address_yuixin = window.localStorage.getItem("address_yuixin");
            if (address_yuixin) {
                this.option.name = JSON.parse(address_yuixin).name;
                this.option.phone = JSON.parse(address_yuixin).phone;
                this.option.provinces = JSON.parse(address_yuixin).provinces;
                this.option.site = JSON.parse(address_yuixin).site;
                this.provincesName = JSON.parse(address_yuixin).provincesName;
            }
        },
        changeAddressFun() {
            this.addressPopupStatus = true;    //地址弹窗状态
        },
        submitFun(option) {
            let self = this;
            self.addressPopupStatus = false;    //地址弹窗状态
            let data = {
                cid: this.cid,
                name: option.name,
                mobile: option.phone,
                pro_code: option.provincesCode[0],
                city_code: option.provincesCode[1],
                gov_code: option.provincesCode[2],
                address: option.site,
            };
            // console.log(data);
            saveAddressApi(data).then((res) => {
                if(res.code == 200){
                    self.setlocalStorageFun(option);
                    self.getAddressFun();
                    self.$toast("修改成功");
                }else{
                    self.$toast(res.msg || '服务器请求错误')
                }                
            });
        },
        go() {
            this.$router.push({
                name: "succeed",
                query: {
                    cid: this.cid,
                },
            });
        },
        payFun() {
            let self = this,data = {
                cid: self.cid,
                product_id: self.plaque ? self.pbType[0].id : self.pbType[1].id,
                sname: self.option.name,
                smobile: self.option.phone,
                spro: self.provincesName[0],
                scity: self.provincesName[1],
                sgov: self.provincesName[2],
                saddress: self.option.site,
                pay_type: !self.payType ? '3' : (self.$store.state.is_weixin_app && !self.$store.state.is_weixin_work) ? '1' : '2', //1微信 2支付宝----1微信mp 2微信h5 3支付宝h5
                quit_url: "https://youxin-gov.cn/payment/" + self.cid+"?succeed=succeed", //成功回调页面
            };
            if (!this.explain) return this.$toast("请勾选同意《立信计划牌匾服务说明》");
            if(self.$route.query.version)data.version = String(self.$route.query.version);
            // console.log('*************',self.$store.state.is_weixin_app)
            orderPayApi(data).then((res) => {
                if(res.code == 200){
                    //判断当前是那个支付方式调用对应的支付逻辑。1微信 2支付宝----1微信mp 2微信h5 3支付宝h5
                    if(data.pay_type == '3'){
                        let div = document.createElement("div");
                        document.body.appendChild(div);
                        div.innerHTML = res.data;
                        self.$nextTick(() => {
                            document.forms[0].submit();
                        });
                    }else if(data.pay_type == '2'){
                        if(res.data && res.data.data)location.href = res.data.data;
                    }else if(data.pay_type == '1'){
                        // self.$toast("当前微信支付正在调试中，请使用支付宝支付");
                        onBridgeReady(res.data, () => {
                            self.go();
                        });
                    }                    
                }else{
                    self.msg = res.msg;
                    self.$refs.mytoast.showFun();
                }
            });
        },
        //轮播图切换事件
        vanSwipeChange(index){
            if(this.initialSwipeNum != index)this.initialSwipeNum = index;
            this.plaque = index==0?true:false; //true 木质牌匾 false 金属牌匾
        },
        //点击指示点切换轮播图
        initialSwipeChange(index){
            if(this.initialSwipeNum != index)this.initialSwipeNum = index;
            this.plaque = index==0?true:false; //true 木质牌匾 false 金属牌匾
            this.$refs.vanSwipeBanner.swipeTo(index);
        },
        //企业名称长度选择字体大小
        planCompantNameLen(str){
            // console.log(str.length)
            let className = "";
            if(str.length>14 && str.length<17){
                className = "comp-name-12";
            }else if(str.length>16 && str.length<20){
                className = "comp-name-11";
            }else if(str.length>19){
                className = "comp-name-10";
            }
            return className;
        }
    },
};
</script>

<style lang="less" scoped>
.payment-page{
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    background: url('../../assets/Image/bg.png') no-repeat;
    background-position: top center;  
    background-size: 100% 100%;  
    .payment-img{
        width: 100%;
        display: block;
    }
    .payment-NoticeBar{
        width: 100%; 
        display: block;
    }
    .payment-content{
        margin-top: 20px;
        width: 340px;   
        padding-bottom: 110px;  
        .payment-banner-price-address-pay-box{  
            margin-bottom: 20px;
            width: 100%;
            padding: 20px;
            box-sizing: border-box;
            border-radius: 14px;
            background: linear-gradient(to bottom, #F4E4D5, rgba(244, 228, 213, 0.2));
            .payment-banner-box{
                width: 100%;
                .banner-item{
                    position: relative;
                }                
                .comp-name {
                    width: 200px;
                    position: absolute;
                    top: 54px;
                    left: 50%;
                    z-index: 9;
                    transform: translateX(-50%);
                    font-size: 13px;
                    text-align: center;
                    font-weight: 600;
                }
                .comp-name-12{
                    top: 54px;
                    font-size: 12px;
                }
                .comp-name-11{
                    top: 50px;
                    font-size: 11px;
                }
                .comp-name-10{
                    top: 50px;
                    font-size: 10px;
                }
                .banner-img{
                    width: 100%;
                    display: block;
                }
                .indicators-list-ul{
                    width: 100%;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-top: 8px;
                    .indicators-list-li{
                        width: 4px;
                        height: 4px;
                        border-radius: 2px;
                        background: rgba(94, 54, 23, 0.5);
                        margin: 0 2px;
                        &.indicator-active{
                            width: 10px;
                            background: rgba(94, 54, 23, 1);
                        }
                    }
                }                
            }  
            //牌匾列表
            .payment-list-ul{
                width: 100%;
                .payment-list-li{
                    width: 100%;
                    margin-top: 15px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    border: 2px solid #FFFFFF;
                    padding: 8px 14px;
                    box-sizing: border-box;
                    border-radius: 14px;
                    background-color: #FFFFFF;
                    .li-title-size{
                        .li-title{
                            font-size: 15px;
                            color: #4C4C4C;
                            line-height: 21px;
                            font-weight: 600;
                        }
                        .li-size{
                            font-size: 12px;
                            color: #999999;
                            line-height: 17px;
                        }
                    }
                    .li-price{                            
                        .span{
                            font-size: 12px;
                            color: #999999;
                            line-height: 34px;
                        }
                        .price-span{
                            margin-left: 4px;
                            font-size: 24px;
                            color: #EA5541;
                            font-weight: 700;
                            line-height: 34px;
                        }
                    }
                }
                .li-active{                    
                    border-color: #5E3617;
                }
            }  
            //收货地址   
            .expressage-list-box{                
                margin-top: 15px;
                width: 100%; 
                border-radius: 14px;
                background-color: #FFFFFF;
                .expressage-icon-provinces{
                    width: 100%;
                    height: 40px;
                    padding: 0 16px;
                    box-sizing: border-box;
                    border-bottom: 1px solid rgba(153, 153, 153, 0.5);
                    display: flex;
                    align-items: center;
                    .expressage-icon{
                        width: 60px;
                        display: block;
                    }
                    .expressage-p{
                        padding: 0 10px;
                        box-sizing: border-box;
                        font-size: 13px;
                        color: #999999;
                        line-height: 16px;
                    }
                    .expressage-first{
                        margin-left: 10px;
                        border-right: 1px solid rgba(153, 153, 153, 0.5);
                    }
                }
                .expressage-addressInfo{
                    width: 100%;
                    padding: 15px 16px;
                    box-sizing: border-box;
                    display: flex;
                    align-items: flex-start;
                    justify-content: space-between;
                    .address-icon{
                        width: 16px;
                        display: block;
                    }
                    .address-info{
                        width: calc(100% - 32px);
                        padding: 0 5px;
                        box-sizing: border-box;
                        .info-name-phone{
                            font-size: 13px;
                            color: #999999;
                            line-height: 18px;
                            .name-span{
                                margin-left: 8px;
                                font-size: 13px;
                                color: #4C4C4C;
                                line-height: 18px;
                                font-weight: 600;
                            }
                            .phone-span{
                                margin-left: 10px;
                                font-size: 13px;
                                color: #4C4C4C;
                                line-height: 18px;
                                font-weight: 600;
                            }
                        }
                        .address-p{    
                            margin-top: 5px;                        
                            font-size: 13px;
                            color: #4C4C4C;
                            line-height: 18px;
                        }
                    }
                    .right-icon{
                        width: 16px;
                        display: block;
                    }
                }
            }
            //支付方式
            .pay-select {              
                margin-top: 15px;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .zfb-wx {
                    width: calc(50% - 2px);
                    height: 40px;
                    border-radius: 14px;
                    border: 2px solid #FFFFFF;
                    background-color: #FFFFFF;
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .zfb-wx-icon {
                        width: 24px;
                        height: 24px;
                        display: block;
                    }
                    .mar84 {        
                        margin-left: 8px;                
                        font-size: 13px;
                        color: #4C4C4C;
                        line-height: 18px;
                    }
                }
                .zfb-wx-active{
                    border-color: #5E3617;
                }
            }
            //流程列表
            .process-list-ul{
                margin-top: 15px;
                width: 100%;
                padding: 15px 0;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;
                border-radius: 14px;
                background-color: #FFFFFF;
                .process-list-li{
                    width: calc(100% / 3);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                    z-index: 3;
                    .li-index{
                        width: 20px;
                        height: 20px;
                        border-radius: 10px;
                        font-size: 11px;
                        color: #FFFFFF;
                        line-height: 20px;
                        text-align: center;
                        font-weight: 600;
                        background: linear-gradient(to bottom, #603718, #C67132);
                    }
                    .li-title{
                        margin-top: 8px;
                        font-size: 13px;
                        color: #5E3617;
                        line-height: 18px;
                    }
                }
                .process-list-li::before{
                    content: '';
                    width: 100%;
                    height: 1px;
                    background: #5E3617;
                    position: absolute;
                    top: 10px;
                    left: 50%;                    
                    z-index: -1;
                }
                .process-list-li:last-child:before{
                    height: 0;
                }
            }
        }
    }
    .payment-btn-select-box{
        width: 100%;
        position: fixed;
        bottom: 0;
        left: 0;right: 0;
        z-index: 3; 
        .payment-btn-img{ 
            width: 100%;
            display: block;
        }   
        .payment-btn-title{
            width: 100%;
            position: absolute;
            top: 25px;
            left: 0;z-index: 3; 
            text-align: center;
            font-size: 18px;
            color: #FDF1C5;
            font-weight: 600;
            line-height: 25px;
        }
        .promiseBook-box{
            width: 100%;
            position: absolute;
            left: 0;bottom: 5px;z-index: 3;   
            display: flex;
            align-items: center;
            justify-content: center;
            .promiseBook-img{
                width: 14px;
                height: 14px;
                display: block;
            }   
            .promiseBook{
                margin-left: 8px;  
                .promiseBook-p{
                    font-size: 14px;
                    color: #854F2D;
                    line-height: 16px;
                }
                .promiseBook-span{ 
                    font-size: 14px;
                    color: #CC8C4E;
                    line-height: 16px;
                }
            } 
        }  
    }
}
</style>